<template>
  <div v-if="show" class="page-bc">
    <div class="page-bc-inner">
      <button class="page-bc-back" @click="goBack" :title="$t('Cabinet')">
        <i class="fas fa-arrow-left"></i>
      </button>
      <a href="#" class="page-bc-link" @click.prevent="goBack">
        {{ $t("Cabinet") }}
      </a>
      <span class="page-bc-sep">/</span>
      <span class="page-bc-curr">{{ $t(titleKey) }}</span>
    </div>
  </div>
</template>

<script>
// Bosqich/tur bo'yicha sarlavha kalitlari (biznes-himoya menyusidagi matnlar bilan bir xil)
const STAGE_TITLES = {
  notified: "BHStageNotified",
  "24h": "BHStage24h",
  criminal: "BHStageCriminal",
};
const KIND_TITLES = {
  profilaktika: "BHProphylactic",
  muloqot: "BHCommunication",
};

export default {
  name: "PageBreadcrumb",
  computed: {
    titleKey() {
      const meta = this.$route.meta || {};
      if (meta.kind && KIND_TITLES[meta.kind]) return KIND_TITLES[meta.kind];
      const stage = this.$route.query.stage;
      if (stage && STAGE_TITLES[stage]) return STAGE_TITLES[stage];
      return meta.title;
    },
    show() {
      const hiddenOn = [
        "Home",
        "Login",
        "Register",
        "Cabinet",
        "Oferta",
        "Privacy",
        "OneIdCallback",
        "BiznesHimoya",
      ];
      if (hiddenOn.indexOf(this.$route.name) !== -1) return false;
      return !!this.titleKey;
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: "Cabinet" });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-bc {
  background: transparent;
  padding: 18px 0 0;
}
.page-bc-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.page-bc-back {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #d9dde6;
  background: #fff;
  color: #293958;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  transition: all 0.15s;
  padding: 0;
  margin-right: 4px;
}
.page-bc-back:hover {
  background: #3f75fe;
  border-color: #3f75fe;
  color: #fff;
}
.page-bc-link {
  color: #3f75fe;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.15s;
}
.page-bc-link:hover {
  color: #293958;
  text-decoration: underline;
}
.page-bc-sep {
  color: #94a3b8;
  font-weight: 600;
}
.page-bc-curr {
  color: #293958;
  font-weight: 600;
}

@media (max-width: 700px) {
  .page-bc-inner {
    padding: 0 14px;
    font-size: 12px;
  }
}
</style>
